"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcautionsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcautionsm` : '') + (description ? ` desc-brandedcautionsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcautionsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcautionsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.87 18.97a1.87 1.87 0 0 1-1.67-2.7L8.32 1.34a1.88 1.88 0 0 1 3.36 0l8.12 14.93a1.86 1.86 0 0 1-1.67 2.7H1.88Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.86 6.39c-.03-.38.19-.68.56-.68h1.14c.37 0 .61.3.58.68l-.1 5.28c-.03.35-.73.57-1.05.57-.32 0-.97-.22-1-.57l-.13-5.28Zm1.13 7c.65 0 1.13.47 1.13 1.09v.16c0 .61-.47 1.09-1.13 1.09a1.1 1.1 0 0 1-1.13-1.1v-.15c0-.62.5-1.09 1.13-1.09Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedcautionsm;